import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/vipImg/vip_recommon_left.png'
import _imports_1 from '@/assets/image/vipImg/vip_recommon_right.png'


const _withScopeId = n => (_pushScopeId("data-v-36c34b3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container wrapper flex-col" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "newer-tips flex-ter"
}
const _hoisted_7 = { class: "price" }
const _hoisted_8 = { class: "line-price" }
const _hoisted_9 = { class: "line-price-value" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "descriptions" }

import { PropType, computed } from 'vue'
import { t } from '@/plugins/i18n'
import { formatMoney } from '@/plugins/utils'
// 推荐内容
interface RecommonItem {
  description: string,
  id: number,
  imageUrl: string,
  isDelete: number,
  membershipTemplateId: number,
  title: string
}

export default /*#__PURE__*/_defineComponent({
  props: {
  list: {
    type: Array as PropType<RecommonItem[]>,
    default: () => []
  },
  newSpecialMemberFlag: {
    type: Boolean,
    default: false
  },
  newSpecialMember: {
    type: Object,
    default: () => { }
  }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('THE CKB专属会员')), 1),
      _hoisted_5
    ]),
    (__props.newSpecialMemberFlag && __props.newSpecialMember.trialDiscount === -1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('新人开通专属会员享')), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(formatMoney)(__props.newSpecialMember.trialPrice)), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(t)('円/首月')), 1),
          _createElementVNode("span", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(formatMoney)(__props.newSpecialMember.discountActualPrice)), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(t)('円/月')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "card",
          key: index
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              class: "img",
              src: item.imageUrl,
              alt: ""
            }, null, 8, _hoisted_12),
            _createElementVNode("div", _hoisted_13, _toDisplayString(item.title), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.description.split(/[(\r\n)\r\n]+/), (description, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "descriptionItem",
                key: index
              }, _toDisplayString(description), 1))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})